import duration from 'duration-js';

export const parseDurationToSeconds = (value: string) =>
  Math.round(duration.parse(value)._milliseconds / 1000);
